import { Navigate } from 'react-router-dom';

// Stock Locations has been merged into the Inventory page under the Locations tab.
// Any bookmarked or linked URLs will redirect automatically.
export default function StockLocationsPage() {
  return <Navigate to="/inventory/search?tab=locations" replace />;
}
